<template>
  <div class="header">
    <ul class="header-nav">
      <li class="header-nav-item" @click="bindNavItem">
        <img src="../../assets/image/nav-icon.png" alt="" :class="['header-nav-item-icon', {'active': showNavContent}]">
        <span class="header-nav-item-text">导航</span>
      </li>
      <li class="header-nav-item" @click="bindWechatCode">
        <img src="../../assets/image/wechat-icon.png" alt="" class="header-nav-item-wechat">
        <span class="header-nav-item-text">微信公众号</span>
        <div class="header-nav-item-code" v-show="isShowWechat">
          <img src="../../assets/image/wechat-code.png" alt="" class="header-nav-item-code-image">
        </div>
      </li>
      <li class="header-nav-item" @click="bindAppletsCode">
        <span class="header-nav-item-text">小程序</span>
        <div class="header-nav-item-code" v-show="isShowApplets">
          <img src="../../assets/image/applets-code.png" alt="" class="header-nav-item-code-image">
        </div>
      </li>
      <li class="header-nav-item">
        <img src="../../assets/image/school-logo.png" alt="" class="header-nav-item-logo" v-if="isLogin">
        <img src="../../assets/image/login-icon.png" alt="" class="header-nav-item-login" v-else>
        <span class="header-nav-item-text" @click="bindPersonalCenter">{{loginTxt}}</span>
        <span class="header-nav-item-text" style="margin-left: 5px" v-if="!isLogin" @click="bindRegisterBtn">注册</span>
      </li>
      <li class="header-nav-item" v-if="isLogin" @click="bindLogoutBtn">
        <span class="header-nav-item-text">退出</span>
      </li>
    </ul>
    <ul :class="['header-content', { 'show-content': showNavContent}]">
      <template v-if="isLogin">
        <li class="header-content-item" v-for="(item, index) in menuList" :key="index" @click="bindContentItem(item, index)">
          <span :class="['header-content-item-text', { 'active': currentIndex === index}]">{{item.menu}}</span>
          <img v-if="item.childs.length" src="../../assets/image/arrow-down-icon.png" alt="" :class="['header-content-item-arrow', {'active': item.showChilds}]">
          <ol class="sub-content" v-if="item.showChilds">
            <li :class="['sub-content-item', {'active': subItem.isActive}]" v-for="(subItem, subIndex) in item.childs" :key="subIndex" @click.stop="bindSubItem(subItem)">{{subItem.name}}</li>
          </ol>
        </li>
      </template>
      <template v-else>
        <li class="header-content-item" v-for="(item, index) in menuList.slice(0, 11)" :key="index" @click="bindContentItem(item, index)">
          <span :class="['header-content-item-text', { 'active': currentIndex === index}]">{{item.menu}}</span>
          <img v-if="item.childs.length" src="../../assets/image/arrow-down-icon.png" alt="" :class="['header-content-item-arrow', {'active': item.showChilds}]">
          <ol class="sub-content" v-if="item.showChilds">
            <li :class="['sub-content-item', {'active': subItem.isActive}]" v-for="(subItem, subIndex) in item.childs" :key="subIndex" @click.stop="bindSubItem(subItem)">{{subItem.name}}</li>
          </ol>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { Header } from '../../common/Header'
export default {
  mixins: [Header],
  data () {
    return {
      isShowWechat: false, // 显示公众号二维码
      isShowApplets: false, // 显示小程序二维码
      menuList: [
        {
          menu: '首页',
          childs: [],
          path: '/index'
        },
        {
          menu: '学校概况',
          showChilds: false,
          childs: [
            { name: '学校简介', path: '/main/schoolsummary', isActive: false },
            { name: '分校简介', path: '/main/branchsummary', isActive: false }
          ]
        },
        {
          menu: '校园资讯',
          showChilds: false,
          childs: [
            { name: '党建新闻', path: '/main/partynews', isActive: false },
            { name: '老年资讯', path: '/main/elderlyinformation', isActive: false },
            { name: '教学动态', path: '/main/teachingtrends', isActive: false },
            { name: '健康生活', path: '/main/healthcare', isActive: false },
            { name: '招生简章', path: '/main/studentgeneralrules', isActive: false }
          ]
        },
        {
          menu: '校园文化',
          showChilds: false,
          childs: [
            { name: '校训校徽', path: '/main/schoolmotto', isActive: false },
            { name: '规章制度', path: '/main/schoolrules', isActive: false },
            { name: '校报校刊', path: '/main/schoolnews', isActive: false },
            { name: '校庆专栏', path: '/main/celebrationcolumn', isActive: false },
            { name: '主题活动', path: '/main/themeactivity', isActive: false }
          ]
        },
        {
          menu: '师生园地',
          showChilds: false,
          childs: [
            { name: '我的收藏', path: '/my/collection', isActive: false },
            { name: '优秀作品', path: '/main/grandworks', isActive: false }
          ]
        },
        {
          menu: '在线教学',
          showChilds: false,
          childs: [
            { name: '互联网+', path: '/main/internet', isActive: false },
            { name: '在线直播', path: '/main/liveonline', isActive: false }
          ]
        },
        {
          menu: '专题学习',
          showChilds: false,
          childs: [
            { name: '健康养生', path: '/main/healthcare', isActive: false }
          ]
        },
        {
          menu: '理论研究',
          showChilds: false,
          childs: [
            { name: '教育工作通讯', path: '/main/educationalnewsletter', isActive: false },
            { name: '交流活动', path: '/main/exchangeactivities', isActive: false }
          ]
        },
        { menu: '师资力量', childs: [], path: '/main/teachersteams' },
        { menu: '课程设置', childs: [], path: '/main/curriculum' },
        {
          menu: '选课报名',
          showChilds: false,
          childs: [
            { name: '课程表', path: '/my/schedule' },
            { name: '全部专业', path: '/my/allmajors' }
          ]
        },
        {
          menu: '我的',
          showChilds: false,
          childs: [
            { name: '我的信息', path: '/my/info', isActive: false },
            { name: '我的课程', path: '/my/course', isActive: false },
            { name: '我的作品', path: '/my/works', isActive: false },
            { name: '中国科学院老干部活动中心', path: '/my/society', isActive: false },
            { name: '抵用券', path: '/my/coupon', isActive: false },
            { name: '帮助', path: '/my/help', isActive: false },
            // { name: '消息同步', path: '/my/messagesync', isActive: false },
            { name: '切换手机号', path: '/my/switchtel', isActive: false }
          ]
        }
      ],
      currentIndex: 0, // 一级导航的索引
      subCurrentIndex: 0, // 二级导航的索引
      showNavContent: false // 显示导航内容
    }
  },
  computed: {
    ...mapGetters(['isLogin']),
    // 登录/我的
    loginTxt () {
      return this.isLogin ? '我的' : '登录'
    }
  },
  watch: {
    $route: {
      handler () {
        this.currentIndex = this.menuList.findIndex(item => item.menu === this.$route.meta.title);
        this.menuList.forEach((item, index) => {
          if (index === this.currentIndex) {
            item.childs.forEach(child => {
              if (child.path === this.$route.path) {
                child.isActive = true
              } else {
                child.isActive = false
              }
            })
          } else {
            item.childs.forEach(child => {
              child.isActive = false
            })
          }
        })
      },
      immediate: true,
      deep: true
    },
    menuList: {
      handler () {
        this.currentIndex = this.menuList.findIndex(item => item.menu === this.$route.meta.title);
        this.menuList.forEach((item, index) => {
          if (index === this.currentIndex) {
            item.childs.forEach(child => {
              if (child.path === this.$route.path) {
                child.isActive = true
              } else {
                child.isActive = false
              }
            })
          } else {
            item.childs.forEach(child => {
              child.isActive = false
            })
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    if(localStorage.getItem('user_token')) this.setIsLogin(true);
    this.getInformationType();
    this.getLearnCategory();
    // this.$root.eventHub.$on('classify_id', (classify_id) => {
    //   if(this.$route.path.indexOf('/internet-') > -1) {
    //     this.currentIndex = 0;
    //   } else {
    //     this.currentIndex = this.menuList.findIndex(item => classify_id == item.id);
    //   }
    // });
  },
  methods: {
    ...mapMutations({
      setIsLogin: 'setIsLogin'
    }),
    // 点击导航
    bindNavItem () {
      this.showNavContent = !this.showNavContent
    },
    // 点击一级导航
    bindContentItem (item, index) {
      if (!item.childs.length && this.currentIndex === index) return
      if (item.path) {
        this.$router.push(item.path)
        this.showNavContent = false
      }
      if (item.childs.length) {
        item.showChilds = !item.showChilds
      }
    },
    // 点击二级导航
    bindSubItem (item) {
      if (!item.path) return
      if (item.isActive) return
      this.$router.push(item.path)
      this.showNavContent = false
    },
    // 点击微信公众号
    bindWechatCode () {
      this.isShowWechat = !this.isShowWechat
    },
    // 点击微信小程序
    bindAppletsCode () {
      this.isShowApplets = !this.isShowApplets
    },
    getlocalStorage (key) {
      var key = 'Api-' + key;
      if(localStorage.getItem(key)) {
        try {
          var data = eval('(' + localStorage.getItem(key) + ')'), now = (new Date()).getTime();
          if(data.expired > now) {
            // console.log('[localStorage] ' + key + ':', data, now);
            return data.data;
          }
        } catch(err) {
          console.log('[localStorage] ' + key + ' Error:', err);
        }
      }
      return null;
    },
    setlocalStorage (key, data) {
      var key = 'Api-' + key;
      localStorage.setItem(key, JSON.stringify({data:data, expired:(new Date()).getTime() + 3600 * 24 *7}));
    },
    // 获取校园资讯分类
    getInformationType () {
      var data = this.getlocalStorage('api2-information_type');
      if(data) {
        this.menuList[2].childs = data;
        return;
      }
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api2&a=information_type').then(function (response) {
        if (response.body.status == 1) {
          this.menuList[2].childs = response.body.data;
          this.setlocalStorage('api2-information_type', response.body.data);
          // this.queryPathIndex();
        }
      }, function (reserror) {
        console.log(reserror);
      })
    },
    // 获取专题学习分类
    getLearnCategory () {
      var data = this.getlocalStorage('api2-build_special_category_api');
      if(data) {
        this.menuList[6].childs = data;
        return;
      }
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api2&a=build_special_category_api').then(function (response) {
        if (response.body.status == 1) {
          this.menuList[6].childs = response.body.data;
          this.setlocalStorage('api2-build_special_category_api', response.body.data);
        }
      }, function (reserror) {
        console.log(reserror);
      })
    },
  }
}
</script>
<style lang="less" scoped>
.header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height:11.47vw;
  background:rgba(1,62,142,1);
  z-index: 100;
  &-nav{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 6.13vw;
    width: 100%;
    height: 100%;
    &-item{
      position: relative;
      display: flex;
      align-items: center;
      padding-right: 3vw;
      padding-left: 3vw;
      border-right: 0.13vw solid #fff;
      &:last-child, &:nth-child(4){
        border-right: none;
      }
      &:last-child, &:nth-child(4){
        padding-right: 0;
      }
      &:first-child{
        position: absolute;
        top: 50%;
        left: 6.13vw;
        transform: translate3d(0, -50%, 0);
        padding: 0;
        border-right: none;
      }
      &-icon{
        width: 3.73vw;
        height: 3.47vw;
        transition: all 0.3s;
        &.active{
          transform: rotate(90deg);
        }
      }
      &-login{
        height: 3vw;
        width: 3vw;
      }
      &-logo{
        margin-right: 1.73vw;
        width: 4.27vw;
        height: 4.27vw;
      }
      &-wechat{
        height: 3vw;
        width: 3vw;
      }
      &-text{
        margin-left: 0.53vw;
        font-size:3.2vw;
        font-family:PingFang SC;
        font-weight:300;
        color:rgba(255,255,255,1);
      }
      &-code{
        position: absolute;
        bottom: -26vw;
        left: 50%;
        margin-left: -11.87vw;
        height: 24.27vw;
        width: 23.87vw;
        background: url('../../assets/image/code-bg.png') no-repeat center center;
        background-size: 100% 100%;
        &-image{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          height: 19.33vw;
          width: 19.33vw;
        }
      }
    }
  }
  &-content{
    position: fixed;
    top: 11.47vw;
    left: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    padding: 0 4vw;
    width: 100%;
    height: 0;
    background: #fff;
    box-sizing: border-box;
    transition: all 0.5s;
    overflow: hidden;
    box-shadow: 0 0.27vw 1.6vw 0 rgba(0, 0, 0, 0.1);
    &.show-content{
      height: 93.33vw;
      overflow: auto;
    }
    &-item{
      position: relative;
      line-height: 13.33vw;
      border-bottom: 0.13vw solid #E6E6E6;
      &:last-child{
        border-bottom: none;
      }
      &-text{
        font-size:4vw;
        font-family:PingFang SC;
        font-weight:300;
        color:rgba(0,0,0,1);
        &.active{
          color: #0066cc;
          font-weight: bold;
          font-weight: 500;
        }
      }
      &-arrow{
        position: absolute;
        right: 1.87vw;
        top: 5.6vw;
        width: 3.6vw;
        height: 2vw;
        transition: all 0.3s;
        &.active{
          transform: rotate(180deg);
        }
      }
      .sub-content{
        display: flex;
        flex-wrap: wrap;
        &-item{
          margin-bottom: 4vw;
          margin-right: 4vw;
          padding: 0 2.13vw;
          height:6.66vw;
          line-height: 6.66vw;
          text-align: center;
          font-size:4vw;
          background:rgba(255,255,255,1);
          border:0.13vw solid rgba(227,227,227,1);
          border-radius:0.67vw;
          box-sizing: border-box;
          // &:nth-child(5n) {
          //   margin-right: 0;
          // }
          &.active{
            border-color: #94B8E9;
            background: #E1EEFF;
          }
        }
      }
    }
  }
}
</style>
